import script from "./SubscribeTable.vue?vue&type=script&lang=js"
export * from "./SubscribeTable.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__